export default __webpack_public_path__ + "static/media/admin-logo-full.994b4b70.svg";